import React, { useEffect, useState } from 'react';
import close from 'icon-close.svg';
import success from 'tick-circle.svg';
import useWindowSize from '../../hooks/useWindowSize';
import { PACKAGES } from '../../../assets/javascripts/optionPackages';

function MarketInquiryForm({ current_user }) {
  const [step, setStep] = useState(1);
  const [formState, setFormState] = useState({});
  const [selectedId, setSelectedId] = useState(null);

  const { width } = useWindowSize();
  const isMobile = width < 768;

  const handlePackageSelect = (e, option) => {
    const { id } = option;
    e.preventDefault();
    setFormState({ ...formState, [e.target.name]: e.target.value });
    setSelectedId(id);
  };

  const handleInput = e => {
    e.preventDefault();
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormState({});
    setStep(1);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setStep(3);

    const {
      package_selection,
      first_name,
      last_name,
      email,
      phone,
      business_name,
      message,
    } = formState;
    document
      .querySelector('form#new_market_business_inquiry #inquiry-submit')
      .click();
  };

  useEffect(() => {
    if (!formState.package_selection) {
      $('.continue-btn').attr('disabled', true);
      $('.continue-btn').addClass('disabled');
    } else {
      $('.continue-btn').attr('disabled', false);
      $('.continue-btn').removeClass('disabled');
    }

    if (
      !formState.business_name ||
      !formState.first_name ||
      !formState.last_name ||
      !formState.email ||
      !formState.phone
    ) {
      $('.submit-btn').attr('disabled', true);
      $('.submit-btn').addClass('disabled');
    } else {
      $('.submit-btn').attr('disabled', false);
      $('.submit-btn').removeClass('disabled');
    }
  });

  useEffect(() => {
    if (formState) {
      Object.entries(formState).forEach(([key, val]) => {
        const inputSelector = document.querySelector(
          `#new_market_business_inquiry #market_business_inquiry_${key}`
        );
        inputSelector.value = val;
      });
    }
  });

  const closeModal = () => {
    const modal = document.getElementById('market-inquiry-form');
    modal.classList.remove('show');
    modal.classList.add('hidden');
    resetForm();
  };

  const packageSelected = () => {
    if (formState.package_selection === 'option_a') {
      return 'Option A';
    }
    if (formState.package_selection === 'option_b') {
      return 'Option B';
    }
    if (formState.package_selection === 'option_c') {
      return 'Option C';
    }
    return '';
  };

  return (
    <aside className="modal-container hidden" id="market-inquiry-form">
      <div className="modal-backdrop" />
      <div className="modal market-business">
        <button type="button" className="market-close-btn" onClick={closeModal}>
          <img src={close} alt="close" />
        </button>
        {step === 1 && (
          <div className="market-form-container">
            <h3 className="selection-header confirm">
              Select a Marketing Package
            </h3>
            <div className="option-card-container">
              {PACKAGES.map((option, index) => (
                <div key={index} className="option-card">
                  <h2 className="option-card-header">{option.title}</h2>
                  <p className="option-card-price">{option.price}</p>
                  <p className="option-card-description">
                    {option.descriptionOne}
                  </p>
                  <p className="option-card-description">
                    {option.descriptionTwo}
                  </p>
                  <p className="option-card-description">
                    {option.descriptionThree}
                  </p>
                  <p className="option-card-description">
                    {option.descriptionFour}
                  </p>
                  <p className="option-card-description">
                    {option.descriptionFive}
                  </p>
                  <p className="option-card-description">
                    {option.descriptionSix}
                  </p>
                  <button
                    type="button"
                    id="package_selection"
                    name="package_selection"
                    value={option.value}
                    onClick={e => handlePackageSelect(e, option)}
                    className={
                      option.id == selectedId
                        ? 'active-market-business'
                        : 'btn--market-business'
                    }
                  >
                    Select Package
                  </button>
                </div>
              ))}
            </div>
            <div className="package-form-actions-container">
              <button
                type="button"
                onClick={() => setStep(2)}
                className="btn btn--blue-grad continue-btn"
              >
                Continue
              </button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <form
              className="market-form-container confirm"
              onSubmit={handleSubmit}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h2 className="selection-header confirm">
                  Confirm Your Contact Information
                </h2>
                {isMobile ? (
                  <p className="option-card-price confirm">
                    Selected Package: {packageSelected()}
                  </p>
                ) : (
                  <p className="option-card-price confirm">
                    I am interested in Package: {packageSelected()}
                  </p>
                )}
                <fieldset>
                  <div className="market-input-row">
                    <div style={{ width: '100%' }}>
                      <label htmlFor="first_name">First name*</label>
                      <input
                        type="first_name"
                        id="first_name"
                        name="first_name"
                        placeholder="First Name"
                        value={formState.first_name}
                        onChange={handleInput}
                      />
                    </div>
                    <div style={{ width: '100%' }}>
                      <label htmlFor="last_name">Last name*</label>
                      <input
                        type="last_name"
                        id="last_name"
                        name="last_name"
                        placeholder="Last Name"
                        value={formState.last_name}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                  <div className="market-input-row">
                    <div style={{ width: '100%' }}>
                      <label htmlFor="email">Email*</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Email"
                        value={formState.email}
                        onChange={handleInput}
                      />
                    </div>
                    <div style={{ width: '100%' }}>
                      <label htmlFor="phone">Phone*</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Phone number"
                        value={formState.phone}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                  <div style={{ paddingBottom: '24px' }}>
                    <label htmlFor="business_name">Business name*</label>
                    <input
                      type="text"
                      id="business_name"
                      name="business_name"
                      placeholder="Business Name"
                      value={formState.business_name}
                      onChange={handleInput}
                    />
                  </div>
                  <div>
                    <label htmlFor="message">
                      Tell us about your business (optional)
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Message"
                      value={formState.message}
                      onChange={handleInput}
                    />
                  </div>
                </fieldset>
                <div className="user-warning">
                  {/* This notice will only be present if user is not logged in */}
                  {!current_user && (
                    <p>
                      We noticed you aren’t logged in or might not have an
                      account yet. By submitting this inquiry, you agree to
                      having a temporary account created using the above
                      information if one doesn’t exist already.
                    </p>
                  )}
                </div>
                <div className="package-form-actions-container confirm">
                  <button
                    type="submit"
                    aria-label="Submit"
                    className="btn btn--blue-grad submit-btn"
                  >
                    Confirm & Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
        {step === 3 && (
          <div className="success-container">
            <img src={success} alt="tick" />
            <h2 className="selection-header">
              Thanks for Selecting a Marketing Package!
            </h2>
            <p
              className="option-card-description"
              style={{ paddingTop: '16px' }}
            >
              One of our agents will be in touch soon.
            </p>
            <a href="/">
              <button
                type="button"
                onClick={closeModal}
                className="btn btn--dark return-btn"
              >
                Return to Home
              </button>
            </a>
          </div>
        )}
      </div>
    </aside>
  );
}

export default MarketInquiryForm;
